import { GTM_ID, isAnalyticsEnabled } from './config';

export const loadGtm = (): void => {
  if (!isAnalyticsEnabled) return;

  const inject = (): void => {
    try {
      window.dataLayer ||= [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);
    } catch {
      // ignored
    }
  };

  const scheduleInject = (): void => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(inject, { timeout: 1500 });
    } else {
      setTimeout(inject, 0);
    }
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', scheduleInject, { once: true });
  } else {
    scheduleInject();
  }
};
